// Type-only import: the runtime side of the card pulls in icon modules, and every consumer of this
// file is a pure module that has no reason to load them. Keeping this import type-only is what lets
// the card import back out of here without a cycle.
import type { TransferProgressData } from "./transfer-progress-card";

export type WithdrawType =
  | "cctp-withdraw"
  | "queued-withdraw"
  | "queued-xchain-withdraw"
  | "xchain-withdraw";

/**
 * Which side of the exchange the funds are moving. The four withdraw arms listed once, so an
 * eighth union arm is classified in one place rather than remembered in several.
 */
export function isWithdrawTransfer(
  transfer: TransferProgressData,
): transfer is TransferProgressData & { type: WithdrawType } {
  return (
    transfer.type === "cctp-withdraw" ||
    transfer.type === "queued-withdraw" ||
    transfer.type === "queued-xchain-withdraw" ||
    transfer.type === "xchain-withdraw"
  );
}

/**
 * The auto-import sentinel: a cross-chain queued withdrawal whose real destination chain is
 * unknown, flagged by `destinationChain === "Aptos"`.
 *
 * Deliberately `boolean` rather than a type guard. Both call sites have already narrowed to the
 * `queued-xchain-withdraw` arm, so a guard asserting that same arm would collapse its own false
 * branch toward `never` and neither site needs the narrowing.
 */
export function isSentinelQueuedXchainWithdraw(transfer: TransferProgressData): boolean {
  return transfer.type === "queued-xchain-withdraw" && transfer.destinationChain === "Aptos";
}
